import { ViewStream } from "spyne";
import { AuthViewProfileListItem } from "components/auth/auth-view-profile-list-item";
import { AuthViewTraits } from "traits/auth-view-traits";

export class AuthViewProfileAppsList extends ViewStream {
  constructor(props = {}) {
    props.tagName = "ul";
    props.traits = [AuthViewTraits];
    props.id = "auth-view-apps-list";

    super(props);
  }

  addActionListeners() {
    return [];
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {
    this.authView$AddListItems();
  }
}
